export  const cakes=[
    { id: 1,
    title:"Ice Cream Sundae Banana Split Cake", 
    img:"photo/fotor-ai-20230723164255_1.jpg", 
    rating:5,
    cost:99.99,
    salePrice:74.99},
    { id: 2,
    title:"Honey Bee Cake", 
    img:"photo/pexels-photo-2684556.jpg", 
    rating:4.5,
    cost:74.99,
    salePrice:64.99},
    { id: 3,
    title:"Soulmate Cake", 
    img:"photo/wedding-cake-g8c2823495_1280 (2).jpg", 
    rating:5,
    cost:149.99,
    salePrice:null},
    {id: 4,
    title:"Donut Cake", 
    img:"photo/cake-gf8a258a43_1280 (1).jpg", 
    rating:4.5,
    cost:129.99,
    salePrice:114.99},
    {id: 5,
    title:"Apple Pie Cake", 
    img:"photo/fotor-ai-20230723164532_2.jpg", 
    rating:4.5,
    cost:39.99,
    salePrice:35.99},
    {id: 6,
    title:"Classic Pound Cake", 
    img:"photo/gugelhupf-ga2142f976_1280.jpg", 
    rating:5,
    cost:34.99,
    salePrice:null},
    {id: 7,
    title:"Sweet Pink Valentine Cake", 
    img:"photo/valentine-g83dc514e5_1280.jpg", 
    rating:4.5,
    cost:149.99,
    salePrice:129.99},
    {id: 8,
    title:"Tropic Swirl Cake", 
    img:"photo/cake-g59407cf4d_1280.jpg", 
    rating:5,
    cost:89.99,
    salePrice:null},
    {id: 9,
    title:"Sunny Mango Cake", 
    img:"photo/crop-cake.png", 
    rating:4.5,
    cost:69.99,
    salePrice:29.99},
    {id: 10,
    title:"Simple Luxury Cake", 
    img:"photo/wedding-gf5e1e2ad8_1280.jpg", 
    rating:4,
    cost:199.99,
    salePrice:149.99},
    { id: 11,
    title:"Strawberry Vanilla Cake", 
    img:"photo/cake-gd77c73efb_1280.jpg", 
    rating:5,
    cost:29.99,
    salePrice:null},
    { id: 12,
    title:"Vanilla Frosting Double Chocolate Cake", 
    img:"photo/cake-3163117_640.jpg", 
    rating:4,
    cost:79.99,
    salePrice:69.99}
    
    ]